// Person commands and enums as exposed by the persons API
// https://prebiller.hc.alpha-cr.com/apis/prebiller-gateway/swagger/docs/v1/persons

export enum PersonTypeEnum {
    NaturalPerson = 1,
    JuridicalPerson = 2
}

export interface CreatePersonCommand {
    personType: PersonTypeEnum;
    businessName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthDate?: Date | string | null;
    birthPlace?: string | null;
    activity?: string | null;
    nationality?: string | null;
}

export interface UpdatePersonCommand extends CreatePersonCommand {
    id: number;
}

export interface PersonFilter {
    SearchText?: string | undefined;
    IdentifierTypeId?: number | undefined;
    Identifier?: string | undefined;
    PageNumber?: number | undefined;
    PageSize?: number | undefined;
}

// Lookup view models returned inside PersonViewModel.
// Gender and MaritalStatus are read only in this application.
export interface PersonLookupViewModel {
    id: number;
    name?: string | null;
    description?: string | null;
    isActive: boolean;
    isDeleted: boolean;
}
